import type { TrackingPropsInterface, TrackingPropsCarousel } from '../../utils/enums/enums';
import type { MMediaSelectorProps } from '../../molecules/MMediaSelector/MMediaSelector.types';
import { MButtonOverlayProps } from '../../molecules/MButtonOverlay/MButtonOverlay.types';

export enum OCarouselGalleryHeroImageScale {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

/**
 * @internal
 * Used by `resolveCarouselType` to map `mCarouselControls.type` strings to
 * a typed enum. Consumers should pass raw strings via `mCarouselControls`
 * rather than importing this enum directly — it may be removed in a future
 * refactor.
 */
export enum OCarouselGalleryHeroCarouselType {
  Dots = 'Dots',
  Numbers = 'Numbers',
}

export interface OCarouselGalleryHeroProps extends React.HTMLAttributes<HTMLDivElement> {
  imageScale?: OCarouselGalleryHeroImageScale;
  mCarouselControls?: { type?: string; imageOverlay?: string | boolean };
  galleryButton?: string | boolean;
  virtualTourButton?: string | boolean;
  /**
   * Array of media items to display in carousel slides.
   * `mMediaCarousel` is omitted: carousel-in-carousel is not supported.
   * Valid mediaType values: Image, ModalVideo, BackgroundVideo.
   */
  mMediaSelectorMulti?: Omit<MMediaSelectorProps, 'mMediaCarousel'>[];
  mButtonOverlayGallery?: Omit<MButtonOverlayProps, 'imageOverlay'>;
  mButtonOverlayVirtualTour?: Omit<MButtonOverlayProps, 'imageOverlay'>;
  trackingProperties?: TrackingPropsInterface & TrackingPropsCarousel;
  className?: string;
}
